import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Megapack Artes Marciales — El Sistema Más Completo para Instructores de Argentina';
// Preconnect to CDN
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// DNS-prefetch for Facebook (deferred pixel)
const dnsPrefetchFb = document.createElement('link');
dnsPrefetchFb.rel = 'dns-prefetch';
dnsPrefetchFb.href = 'https://connect.facebook.net';
document.head.appendChild(dnsPrefetchFb);
// Preload the actual hero/LCP image (must match the src in App.tsx)
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.type = 'image/webp';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/1oGQeRLN1m8EVFzXgb5m6U/Gemini_Generated_Image_4czaxo4czaxo4cza-Photoroom.webp';
document.head.appendChild(preloadImg);
render(<App data-id="element-355" />, document.getElementById('root'));